var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"divider"},[_c('div',{staticClass:"lineContainer"}),(_vm.label !== '')?_c('div',{staticClass:"labelDivider"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"lineContainer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }